/* 
 * Teams Grid Block AJAX JS
 */

'use strict';

var $ = require('jquery');

// Set first page on load
let current_page = 1;

$('#team-load-more').on('click', function() {
	current_page++;
	const $load_more_btn = $(this);
	const team_cat = $load_more_btn.attr('team-cat');
	const team_num = $load_more_btn.attr('team-num');
	const max_num  = $load_more_btn.attr('max-posts');
	const btn_text = $load_more_btn.html();

	$.ajax({
		type: 'POST',
		url: '/cms/wp-admin/admin-ajax.php',
		dataType: 'html',
		data: {
			action: 'teams_load_more',
			paged: current_page,
			cat: team_cat,
			posts_num: team_num
		},
		beforeSend: function() {
			$load_more_btn.addClass( 'loading' );
			$load_more_btn.html( 'Loading...' );
		},
		success: function (res) {
			$load_more_btn.removeClass( 'loading' );
			$load_more_btn.html( btn_text );
			$('.teams-grid-container').append(res);

			// Hide button block if max number of pages hit
			if ( max_num <= current_page ) {
				$load_more_btn.closest('.wp-block-buttons').hide();
			}
		}
	});

	return false;
});
